import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {FlightsDatesSelector} from "../../../services/flight-search/dates-selection/flights-dates-selector";
import {
    DepartureDateSelectionStrategyIndicatorComponent,
    ReturnDateSelectionStrategyIndicatorComponent
} from "./open-state/date-selection-strategy-indicator.component";
import {useServices} from "../../../hooks/use-services.hook";
import {composeFlightDatesDropDownHeaderTitle} from "./compose-flight-dates-drop-down-header-title";
import {IDropDownController} from "../../drop-down/drop-down-controller.interface";
import {MobileDropDownListHeaderComponent} from "../../drop-down/mobile-drop-down-list-header/mobile-drop-down-list-header.component";


const TitleContainerBox = styled.div`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
    
`

interface FlightDatesDropdownMobileHeaderComponentProps {
    datesSelector: FlightsDatesSelector;
    dropDownController: IDropDownController;
}
export const FlightDatesDropdownMobileHeaderComponent: React.FC<FlightDatesDropdownMobileHeaderComponentProps> = observer((props) => {
    const services = useServices();

    const renderTitleContent = () => {
        if(!props.datesSelector.searchController.departureDate && !props.datesSelector.searchController.returnDate) {
            return composeFlightDatesDropDownHeaderTitle(props.datesSelector.searchController, services);
        } else {
            return (
                <>
                    <DepartureDateSelectionStrategyIndicatorComponent datesSelector={props.datesSelector}/>
                    <ReturnDateSelectionStrategyIndicatorComponent datesSelector={props.datesSelector}/>
                </>
            );
        }
    }

    const onClose = () => {
        props.dropDownController.closeDropDown();
    }

    return (
        <MobileDropDownListHeaderComponent onBackClick={onClose}>
            <TitleContainerBox>
                {renderTitleContent()}
            </TitleContainerBox>
        </MobileDropDownListHeaderComponent>

    );
});
